
/**
 * Type of tweet
 */
export type GetTweetById200TweetType = typeof GetTweetById200TweetType[keyof typeof GetTweetById200TweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetById200TweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
} as const;
